export default {
  "figure": "YbNTn"
};